// extracted by mini-css-extract-plugin
export default {"title":"IntakeHeader_title__dsM6I","description":"IntakeHeader_description__2wxLu"};